import { useEffect, useState } from "react";
import {
  getPicklist,
  createAndSendOtpRegistration } from
"../../services/epic/bloodDonation";
import AlertDependent from "../../common/AlertDependent";
import { isValidUAENumber } from "../../utils/util";
import OtpVerificationRegistration from "./OtpVerificationRegistration";
import { config } from "../../utils/constants";
import RegistrationThanks from "./RegistrationThanks";
import { Loader } from "../../common/Loader";

const Registration = ({
  setRequestStep,
  translationMap
}) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [fullName, setFullName] = useState("");
  const [list, setList] = useState([]);
  const [error, setError] = useState("");
  const [alert, setAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [mobileVerification, setMobileVerification] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [registrationThanks, setRegistrationThanks] = useState(false);
  const [regsStart, setRegsStart] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [regsMobileNum, setRegsMobileNum] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    window.parent.scrollTo(0, 0);
    getPicklist().then((result) => {
      let names = result?.data?.listTypeEntries.map((entry) => entry.name);
      names.sort();
      names.push(translationMap?.iDontKnow);
      setList(names);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const preventInvalidNameInput = (event) => {
    const regex = /^[\u0600-\u06FFa-zA-Z\s]*$/;
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  };

  const preventInvalidMobileInput = (event) => {
    const regex = /^\d$/;
    const value = event.target.value;

    if (!regex.test(event.key) || value.length >= 9) {
      event.preventDefault();
    }
  };

  const handleNameChange = (event) => {
    const value = event?.target?.value;
    const sanitizedValue = value.replace(/[^a-zA-Z\u0600-\u06FF\s]/g, "").replace(/^\s+/, "");
    if (sanitizedValue !== value) {
      event.preventDefault();
      setError(translationMap?.pleaseTypeYourName || "Please type your name");
    } else {
      setError("");
    }
    setFullName(sanitizedValue);
    setIsButtonDisabled(
      !(
      sanitizedValue &&
      regsMobileNum.length === 9 &&
      isValidUAENumber(regsMobileNum) &&
      selectedOption)

    );
  };

  const handleMobileNumberChange = (event) => {
    const value = event?.target?.value;
    if (/^\d*$/.test(value) && value.length <= 9) {
      setRegsMobileNum(value);
      if (value.length === 0) {
        setErrorMessage("");
        setIsButtonDisabled(true);
      } else if (value.length === 9 && isValidUAENumber(value)) {
        setErrorMessage("");
        setIsButtonDisabled(!(fullName && selectedOption));
      } else if (value.length === 9) {
        setErrorMessage(
          translationMap?.pleaseEnterValidUAENO
        );
        setIsButtonDisabled(true);
      } else {
        setErrorMessage(
          translationMap?.mobileNoMustBeTen
        );
        setIsButtonDisabled(true);
      }
    } else {
      event.preventDefault();
    }
  };

  const validateForm = () => {
    return (
      fullName &&
      regsMobileNum &&
      selectedOption &&
      regsMobileNum.length === 9 &&
      isValidUAENumber(regsMobileNum));

  };

  const submitRegistration = async () => {
    const cleanMobileNo = `${config?.uaeCountryCode}${regsMobileNum}`;
    setRegsMobileNum(cleanMobileNo);
    setOtpError(false);
    if (!validateForm()) {
      setAlert(translationMap?.enterAllFields);
      return;
    }
    setIsLoading(true);
    const info = await createAndSendOtpRegistration(cleanMobileNo, fullName, selectedOption);
    setIsLoading(false);
    if (info?.data?.message === "otpBlocked")
    {
      // setIsLoading(false);
      setOtpError(true);
      return;
    } else {
      const idInfo = info?.data?.id;
      setId(idInfo);
      // setIsLoading(false);
      setMobileVerification(true);
    }
  };

  const onSelectValue = (event) => {
    setSelectedOption(event?.target?.value);
    setIsButtonDisabled(
      !(
      regsMobileNum.length === 9 &&
      isValidUAENumber(regsMobileNum) &&
      fullName &&
      event.target.value)

    );
  };

  if (isLoading)
  {
    return (
      <Loader />);

  }

  return (
    <>
    {regsStart &&
      <section
        className="w-100 clearfix BloodDonationMainSection"
        id="CoverPlanActive">
        
       <div className="container customContainer">
         <div className="Title_Inner_Box">
           <h6 className="MainTitleOne">
             {translationMap?.registerEmergency}
           </h6>
         </div>
         <div className="cover_inner_wrapper">
           <div className="cover_main_box1">
             <div className="donation_question_box">
               <div className="answer_box">
                 <p className="MainTitleOne">
                   {translationMap?.registerEmergencyMsg}&nbsp;
                   {translationMap?.registerEmergencyMsg1}
                 </p>
               </div>
             </div>
             {alert &&
              <AlertDependent
                setError={setAlert}
                alert_text="You have already registered with same mobile no." />

              }
             {otpError &&
              <AlertDependent
                setError={setOtpError}
                alert_text={translationMap?.otpBlocked} />

              }
             <div className="dependent_form_box">
               <div className="inner_title_txt_box">
                 <p className="Gray_Title">
                   {translationMap?.pleaseEnterInfo}
                 </p>
               </div>
               <form onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    document.getElementById("registerButton")?.click();
                  }
                }}>
                 <div className="form_inner_box">
                   <div className="inner_input_box">
                     <div className="input_box">
                       <label>{translationMap?.fullName}</label>
                       <div className="input_wrap">
                         <input
                            type="text"
                            name="full name"
                            value={fullName}
                            onChange={handleNameChange}
                            onKeyDown={preventInvalidNameInput}
                            placeholder={translationMap?.enterFullName}
                            maxLength={100}
                            style={{
                              borderColor: error ?
                              "#FF8F8A" :
                              "rgb(128 153 178)"
                            }} />
                          
                         {error &&
                          <span id="text" style={{ color: "#FF8F8A" }}>
                             {error}
                           </span>
                          }
                       </div>
                     </div>
                   </div>
                   <div className="inner_input_box custom_input_box">
                     <div className="input_box">
                       <label>{translationMap?.phoneNo}</label>
                       <div className="input number_input_field">
                         <input
                            type="number"
                            onChange={handleMobileNumberChange}
                            value={regsMobileNum}
                            className="input_field"
                            inputmode="numeric"
                            onKeyPress={preventInvalidMobileInput}
                            name="number"
                            placeholder="5xx xxx xxx"
                            style={{
                              borderColor: errorMessage ?
                              "#FF8F8A" :
                              "rgb(128 153 178)"
                            }} />
                          
                         <span className="input-group-addon" style={{ direction: "ltr" }}>+971</span>
                         {errorMessage &&
                          <span id="text" style={{ color: "#FF8F8A" }}>
                             {errorMessage}
                           </span>
                          }
                       </div>
                     </div>
                   </div>
                 </div>
                 <div className="Inner_Box">
                   <div className="input_field_box">
                     <div className="input_inner_box">
                       <div className="row ">
                         <div className="col-12 col-md-12 col-lg-6">
                           <div className="select_custom_box" id="hockey">
                             <label for="html">
                               {translationMap?.bloodGroup}
                             </label>
                             <div className="dropdown-form">
                               <select
                                  onChange={(event) => onSelectValue(event)}
                                  value={selectedOption}>
                                  
                                 <option value="">
                                   {translationMap?.selectBloodGrp}
                                 </option>
                                 {list?.map((item, index) => {
                                    return (
                                      <option key={index} value={item}>
                                       {item}{" "}
                                     </option>);

                                  })}
                               </select>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>

                 <div className="form_btn_box">
                   <span>
                     {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                     <a
                        id="registerButton"
                        onClick={submitRegistration}
                        className={
                        isButtonDisabled ?
                        "disabled_btn_link" :
                        "bluetrans_btn_link"
                        }>
                        
                       {translationMap?.register}
                     </a>
                   </span>
                   <span>
                     {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                     <a
                        className="bluetrans_btn_link"
                        onClick={() => {
                          setRequestStep(-1);
                          window.parent.scrollTo(0, 0);
                          setRegsMobileNum("");
                        }}>
                        
                       {translationMap?.backToDammi}
                     </a>
                   </span>
                 </div>
               </form>
             </div>
           </div>
           <div className="cover_main_box2"></div>
         </div>
       </div>
     </section>
      }
      {mobileVerification &&
      <OtpVerificationRegistration
        setRequestStep={setRequestStep}
        setMobileVerification={setMobileVerification}
        mobileNum={regsMobileNum}
        fullName={fullName}
        bloodGroup={selectedOption}
        setRegsStart={setRegsStart}
        setRegistrationThanks={setRegistrationThanks}
        id={id}
        translationMap={translationMap} />

      }
      {registrationThanks &&
      <RegistrationThanks
        setRequestStep={setRequestStep}
        regsMobileNum={regsMobileNum}
        setRegsMobileNum={setRegsMobileNum}
        fullName={fullName}
        bloodGroup={selectedOption}
        setRegistrationThanks={setRegistrationThanks}
        translationMap={translationMap} />

      }
    </>);

};

export default Registration;